import { Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { IndexPath } from '@/Config/app/router/index.path';
import { useCurrentIndexPath } from '@/Config/app/router/useIndexPath.hook';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/Domain/components/Shared/Sidebar/Sidebar';

export const SidebarSettingsButton = () => {
  const { t } = useTranslation('sidebar_menu');
  const currentPath = useCurrentIndexPath();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          asChild
          tooltip={t('menu.account.settings')}
          isActive={currentPath === IndexPath.settings}
        >
          <NavLink to={IndexPath.settings} viewTransition>
            <Settings size={16} />
            <span>{t('menu.account.settings')}</span>
          </NavLink>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
